import $api from "@/zapi-frontend/shared/api/axios";
import { TNotification } from "./store";

type TNotificationsResponse = {
  notifications: TNotification[];
};

export async function fetchAllNotifications(): Promise<TNotification[]> {
  const response = await $api.get<TNotificationsResponse>("/user/notifications");

  return response.data.notifications;
}

export async function markNotificationAsRead(notificationId: number): Promise<void> {
  await $api.post("/user/notifications/mark-read", { notificationId });
}

export async function markAllNotificationsAsRead(): Promise<void> {
  await $api.post("/user/notifications/mark-all-read");
}
